import React, {createRef, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import {trackGaussEvent} from "../helper/analytics";

export function PrivateclassSearch({}) {
    const refinput = createRef()

    useEffect(() => {
        if(!refinput.current) return

        const listener = (event) => {
            refinput.current.value = ''
        }

        document.addEventListener('privateclass_menu_tabs', listener)

        return () => {
            document.removeEventListener('privateclass_menu_tabs', listener)
        }
    }, [refinput])

    let timeout = null
    const onChangeInput = (event) => {
        const value = event.target.value.toLowerCase();
        const e =  new CustomEvent('masterclass_search_query', {detail : value})

        document.dispatchEvent(e)

        if(timeout) clearTimeout(timeout)

        timeout = setTimeout(() => {
            if(value.length > 0) {
                trackGaussEvent('search_on_course', {
                    url: window.location.href,
                    query: value
                })
            }
        }, 500)
    }

    return(
        <Container>
            <InputText ref={refinput} onChange={onChangeInput} type='text' placeholder={'Buscar'} />
        </Container>
    )
}

const InputText = styled.input`
    padding: 8px 12px;
    margin-left: 12px;
    margin-bottom: 12px;
    font-size: 14px;
`

const Container = styled.div`
    padding: 12px;
    display: flex;
    flex-direction: column;
`

if (document.getElementsByTagName('privateclass-menu-search')) {
    const elms = document.getElementsByTagName('privateclass-menu-search')

    for(let elm of elms) {
        ReactDOM.render(<PrivateclassSearch  />, elm);
    }
}
